export class InvalidUsdAmountError extends Error {
  public constructor() {
    super("Enter a positive USD amount with no more than two decimal places.");
    this.name = "InvalidUsdAmountError";
  }
}

export function minorUnitsToUsd(minorUnits: string): string {
  if (!/^\d+$/.test(minorUnits)) return "";
  const value = BigInt(minorUnits);
  const dollars = value / 100n;
  const cents = (value % 100n).toString().padStart(2, "0").replace(/0+$/, "");
  return cents === "" ? dollars.toString() : `${dollars.toString()}.${cents}`;
}

export function usdToMinorUnits(usd: string): string {
  const match = /^(0|[1-9]\d*)(?:\.(\d{1,2}))?$/.exec(usd.trim());
  if (match === null) throw new InvalidUsdAmountError();
  const dollars = BigInt(match[1] ?? "0");
  const cents = BigInt((match[2] ?? "").padEnd(2, "0") || "0");
  const minorUnits = dollars * 100n + cents;
  if (minorUnits <= 0n) throw new InvalidUsdAmountError();
  return minorUnits.toString();
}
